import React from 'react';
import { IntlProvider } from 'react-intl';
import ContentPickerPopup from 'box-ui-elements/es/elements/content-picker/ContentPickerPopup.js';
import axios from 'axios';

import {
  getCookie,
} from '../../utils/cookies';

export default function ContentPickerPopupBox(props) {
  const downloadFileName = 'AmfamBox_files';
  const accessToken = JSON.parse(getCookie('boxToken')).accessToken;

  const downloadSelectedItems = (selections) => {
    let items = [];
    selections.map(selection => 
      items.push({
        id: selection.id,
        type: selection.type
      })
    );

    axios({
      url: 'https://api.box.com/2.0/zip_downloads',
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      data: {
        items,
        download_file_name: downloadFileName
      }
    })
    .then(zipResp => {
      props.onDownload(zipResp.data.download_url);
    });
  }

  const addRefreshedAccessTokenHeader = (config) => {
    config.headers['Authorization'] = 'Bearer ' + JSON.parse(getCookie('boxToken')).accessToken;
    return config;
  }

  return (
    <div>
      <IntlProvider locale="en" textComponent={React.Fragment}>
        <ContentPickerPopup
          rootFolderId="0"
          token={JSON.parse(getCookie('boxToken')).accessToken}
          logoUrl=""
          canCreateNewFolder={false}
          canSetShareAccess={false}
          canUpload={false}
          chooseButtonLabel='Download'
          cancelButtonLabel='Cancel'
          type='file,folder'
          modal={{
            buttonLabel: 'Click Here to Download Folders/Multiple Files'
          }}
          onChoose={downloadSelectedItems}
          requestInterceptor={addRefreshedAccessTokenHeader}
        />
      </IntlProvider>
    </div>
  );
}
